import { Badge as MuiBadge, styled } from '@mui/material';
import React from 'react';
import { BadgeColor, BadgeProps } from './types';

export const Badge: React.FC<BadgeProps> = ({ children, color = 'primary', ...props }) => {
    if (!children) return <StandaloneBadge color={color} {...props} />;
    return (
        <MuiBadge color={color} {...props}>
            {children}
        </MuiBadge>
    );
};

const StandaloneBadge = styled(MuiBadge)<{ color: BadgeColor }>(({ theme, color }) => ({
    '.MuiButton-contained & .MuiBadge-badge': {
        backgroundColor: theme.palette[color].contrastText,
        color: theme.palette[color].main || color,
    },
    '.Mui-disabled & .MuiBadge-badge': {
        backgroundColor: theme.palette.text.disabled,
        color: theme.palette.background.paper,
    },
    '.MuiButton-contained.Mui-disabled & .MuiBadge-badge': {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.disabled,
    },
    span: { position: 'relative', transform: 'none' },
}));
